import apiClient from "../../axios/apiClient";

export const getVolveConfigurationList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_VOLVE_CONFIGURATION_LIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/volve-configuration`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_VOLVE_CONFIGURATION_LIST_FULFILLED",
        payload: response?.data?.data,
        volveConfigurationCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      dispatch({
        type: "GET_VOLVE_CONFIGURATION_LIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveVolveConfigurationList =
  (token, data) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_VOLVE_CONFIGURATION_LIST_PENDING" });

      const response = await apiClient.post(
        `/api/v1/volve-configuration`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_VOLVE_CONFIGURATION_LIST_FULFILLED",
        payload: response.data?.data,
        volveConfigurationCount: response.data?.count,
        permissions: response.data?.permissions,
      });
      dispatch({ type: "ADD_VOLVE_CONFIGURATION_FULFILLED", payload: response.data });
    } catch (error) {
      dispatch({ type: "ADD_VOLVE_CONFIGURATION_REJECTED", payload: error.response });
    }
  };
  

  export const getVolveConfigurationById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_VOLVE_CONFIGURATION_BY_ID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/volve-configuration/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_VOLVE_CONFIGURATION_BY_ID_FULFILLED",
        payload: response.data?.data,
        volveConfigurationCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_VOLVE_CONFIGURATION_BY_ID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateVolveConfigurationData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_VOLVE_CONFIGURATION_PENDING" });
    console.log(data);

    const response = await apiClient.put(
      `/api/v1/volve-configuration/${id}`, // Endpoint URL with City ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_VOLVE_CONFIGURATION_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_VOLVE_CONFIGURATION_REJECTED", payload: error.response });
  }
};




export const deleteVolveConfigurationData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_VOLVE_CONFIGURATION_PENDING" });

    const response = await apiClient.delete(
      `/api/v1/volve-configuration/${id}`, // Endpoint URL with City ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_VOLVE_CONFIGURATION_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_VOLVE_CONFIGURATION_REJECTED", payload: error.response });
  }
};
